import * as React from "react";
import { IButtonStyles, IconButton, IContextualMenuItem, registerIcons } from "@fluentui/react";
import { MoreDotsSvg } from "../Svg/icons";
import { ActionMenuItem } from "./ListingTypes";

export interface ListingActionMenuProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  rowValue: any;
  actions: ActionMenuItem []
  testId?: string;
}

const btnStyles: IButtonStyles = { root: { height: 20 } };

registerIcons({ icons: { "more-dots-svg": MoreDotsSvg } });

export const ListingActionMenu = ({ rowValue, actions, testId }: ListingActionMenuProps): JSX.Element => {
  const items: IContextualMenuItem[] = actions.map(action => ({
    "data-test-id": action.testId,
    key: action.key,
    name: action.name,
    iconProps: { iconName: action.icon },
    onClick: () => action.onClick(rowValue),
  }));
  return (
    <IconButton
      data-test-id={testId}
      iconProps={{ iconName: "more-dots-svg", styles: { root: { position: "absolute", top: "2px" } } }}
      menuIconProps={{ iconName: "" }}
      menuProps={{ items }}
      styles={btnStyles}
    />
  );
};
